<div class="m-t-40" *ngIf="ready && shouldShow">
  <h5>Attention!</h5>
  <span>You are eligible for a discounted loyalty upgrade price on a new PreSonus mixer or interface.</span>
  <br />
  <a class="btn btn-primary m-t-10" href="https://www.presonus.com/catalinaloyalty/" target="_blank">Learn More</a>
</div>
